import React from 'react'

import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form'

import { LinkContainer } from 'react-router-bootstrap';

import FormField from '../field/FormField';


var LoginForm = props => {
  var { error, handleSubmit, pristine, reset, submitting } = props

  return (
    <div>
      <div className="row justify-content-md-center" >
        <div className="jumbotron col-sm-8">
          <form onSubmit={handleSubmit}>
            <Field
              name="username"
              type="text"
              component={FormField}
              label="Email"
            />
            <Field
              name="password"
              type="password"
              component={FormField}
              label="Password"
            />

            {error && <strong>{error}</strong>}
            <div className="button-row">
              <LinkContainer to="/sign-up">
                <button type="button" className="btn btn-light">Sign Up</button>
              </LinkContainer>
              <button type="submit" className="btn btn-primary" disabled={submitting}>Log In</button>
              <button className="hidden" type="button" disabled={pristine || submitting} onClick={reset}>
                Clear Values
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  )
}

const mapStateToProps = () => ({
  initialValues: {
    username: localStorage.getItem('user_id'),
  },
});

export default connect(mapStateToProps)(
  reduxForm({
    form: 'loginpage', //Form name is same
    destroyOnUnmount: true,
    forceUnregisterOnUnmount: true, // <------ unregister fields on unmount
    //validate
  })(LoginForm)
);

